module.exports = __webpack_public_path__ + "img/tickets-v2.9c7418c2.svg";